import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environement/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GeneralServiceService {

  constructor(private http: HttpClient) { }

  categoryName : any

  setCategory(category : any){
    this.categoryName = category;
  }

  getCategory(){
    return this.categoryName;
  }

  verifyUser(email: any, password:any): Observable<any> {
    const body = { email, password };
    return this.http.post(`${environment.baseUrl}/api/login`, body);
  }

  fetchDatosDataDetails(): Observable<any> {
    const token = sessionStorage.getItem("token") || '';
    const location = sessionStorage.getItem("Location")
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.http.get<any>(`${environment.baseUrl}/api/getAllDatosGeneralesDetails/${location}`, { headers });
}

  fetchDatosData(searchData: any): Observable<any> {
    const { location, razon_social, rfc, numero_de_immex, domicilio_fiscal } = searchData;
    const token = sessionStorage.getItem("token") || '';  // Retrieve token from session storage

    let params = new HttpParams()
      .set('location', location || '')
      .set('razon_social', razon_social || '')
      .set('rfc', rfc || '')
      .set('numero_de_immex', numero_de_immex || '')
      .set('domicilio_fiscal', domicilio_fiscal || '')
      .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
      .set('start', '0')
      .set('length', '10');

    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.http.get<any>(`${environment.baseUrl}/api/getAllDatosGenerales`, { headers, params });
}

fetchDataMaterialesService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    arancelaria, 
    arancelariaOperator, 
    descripcion, 
    descripcionOperator, 
    unidad, 
    unidadOperator, 
    fecha, 
    fechaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('arancelaria', arancelaria || '')
    .set('arancelariaOperator', arancelariaOperator || '')
    .set('descripcion', descripcion || '')
    .set('descripcionOperator', descripcionOperator || '')
    .set('unidad', unidad || '')
    .set('unidadOperator', unidadOperator || '')
    .set('fecha', fecha || '')
    .set('fechaOperator', fechaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllMateriales`, { headers, params });
}

fetchDataProductosService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    arancelaria, 
    arancelariaOperator, 
    descripcion, 
    descripcionOperator, 
    unidad, 
    unidadOperator, 
    fecha, 
    fechaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('arancelaria', arancelaria || '')
    .set('arancelariaOperator', arancelariaOperator || '')
    .set('descripcion', descripcion || '')
    .set('descripcionOperator', descripcionOperator || '')
    .set('unidad', unidad || '')
    .set('unidadOperator', unidadOperator || '')
    .set('fecha', fecha || '')
    .set('fechaOperator', fechaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllProductos`, { headers, params });
}

fetchDataEntradasService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    numero, 
    numeroOperator, 
    clave, 
    claveOperator, 
    fecha, 
    fechaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('numero', numero || '')
    .set('numeroOperator', numeroOperator || '')
    .set('clave', clave || '')
    .set('claveOperator', claveOperator || '')
    .set('fecha', fecha || '')
    .set('fechaOperator', fechaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllEntradas`, { headers, params });
}

fetchDataUtilizadosService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    numero, 
    numeroOperator,
    descripcion, 
    descripcionOperator, 
    unidad, 
    unidadOperator, 
    cantidad, 
    cantidadOperator, 
    fecha, 
    fechaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('numero', numero || '')
    .set('numeroOperator', numeroOperator || '')
    .set('descripcion', descripcion || '')
    .set('descripcionOperator', descripcionOperator || '')
    .set('unidad', unidad || '')
    .set('unidadOperator', unidadOperator || '')
    .set('cantidad', cantidad || '')
    .set('cantidadOperator', cantidadOperator || '')
    .set('fecha', fecha || '')
    .set('fechaOperator', fechaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllUtilizados`, { headers, params });
}

fetchDataSalidasService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    numero, 
    numeroOperator, 
    clave, 
    claveOperator, 
    fecha, 
    fechaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('numero', numero || '')
    .set('numeroOperator', numeroOperator || '')
    .set('clave', clave || '')
    .set('claveOperator', claveOperator || '')
    .set('fecha', fecha || '')
    .set('fechaOperator', fechaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllSalidas`, { headers, params });
}

fetchDataFijoService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    numero, 
    numeroOperator,
    descripcion, 
    descripcionOperator,
    clave, 
    claveOperator, 
    fecha, 
    fechaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('numero', numero || '')
    .set('numeroOperator', numeroOperator || '')
    .set('descripcion', descripcion || '')
    .set('descripcionOperator', descripcionOperator || '')
    .set('clave', clave || '')
    .set('claveOperator', claveOperator || '')
    .set('fecha', fecha || '')
    .set('fechaOperator', fechaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllFijo`, { headers, params });
}

fetchDataTempEntradaService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    numero, 
    numeroOperator, 
    clave, 
    claveOperator, 
    fecha, 
    fechaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('numero', numero || '')
    .set('numeroOperator', numeroOperator || '')
    .set('clave', clave || '')
    .set('claveOperator', claveOperator || '')
    .set('fecha', fecha || '')
    .set('fechaOperator', fechaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllTempEntrada`, { headers, params });
}

fetchDataTempSalidaService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    numero, 
    numeroOperator, 
    clave, 
    claveOperator, 
    fecha, 
    fechaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('numero', numero || '')
    .set('numeroOperator', numeroOperator || '')
    .set('clave', clave || '')
    .set('claveOperator', claveOperator || '')
    .set('fecha', fecha || '')
    .set('fechaOperator', fechaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllTempSalida`, { headers, params });
}

fetchDataSaldosService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    arancelaria, 
    arancelariaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('arancelaria', arancelaria || '')
    .set('arancelariaOperator', arancelariaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllSaldos`, { headers, params });
}

fetchDataTempUtilizadosService(searchData: any): Observable<any> {
  const { 
    razon_social, 
    rfc, 
    numero, 
    numeroOperator,
    descripcion, 
    descripcionOperator, 
    unidad, 
    unidadOperator,
    fecha, 
    fechaOperator,
    start,
    length
  } = searchData;

  const token = sessionStorage.getItem("token") || '';

  let params = new HttpParams()
    .set('location', sessionStorage.getItem('Location') || '')
    .set('razon_social', razon_social || '')
    .set('rfc', rfc || '')
    .set('numero', numero || '')
    .set('numeroOperator', numeroOperator || '')
    .set('descripcion', descripcion || '')
    .set('descripcionOperator', descripcionOperator || '')
    .set('unidad', unidad || '')
    .set('unidadOperator', unidadOperator || '')
    .set('fecha', fecha || '')
    .set('fechaOperator', fechaOperator || '')
    .set('order', JSON.stringify([{ column: 1, dir: 'asc' }]))
    .set('start', start)
    .set('length', length);

  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  return this.http.get<any>(`${environment.baseUrl}/api/getAllTempUtilizados`, { headers, params });
}

logout(email: any, location: any, event : any): Observable<any[]> {
  const params = new HttpParams()
    .set('email', email)
    .set('event', event)
    .set('location', location);
  const token = sessionStorage.getItem("token") || '';
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  return this.http.get<any[]>(`${environment.baseUrl}/api/logout`, { headers, params });
}

logoutSession(email: any, location: any, event : any): Observable<any[]> {
  console.log("Inside general Service")
  const params = new HttpParams()
    .set('email', email)
    .set('event', event)
    .set('location', location);

  return this.http.get<any[]>(`${environment.baseUrl}/api/logoutSession`, { params });
}

}
